import React from 'react'
import { StyledLoadMoreButton } from '../style'

const LoadMoreButton = ({ loadMore, margin }) => {
  return (
    <StyledLoadMoreButton
      onClick={loadMore}
      aria-label="Load more"
      color="navy"
      hoverColor="white"
      margin={margin}
    >
      Load more
    </StyledLoadMoreButton>
  )
}

export default LoadMoreButton
